import React from "react";
import { LazyLoadUtils } from "../../utils/index.js";

export const LanguagesMenu = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "menu/language" */
      "./LanguagesMenu.js"
    ),
  { componentName: "LanguagesMenu" }
);

export const LanguagesMenuPC = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "menu/pc/languages" */
      "./LanguagesMenu.pc.js"
    ),
  { componentName: "LanguagesMenuPC" }
);

export const LanguagesMenuMobile = LazyLoadUtils.lazyWithFallback(
  () =>
    import(
      /* webpackChunkName: "menu/mobile/languages" */
      "./LanguagesMenu.mobile.js"
    ),
  { componentName: "LanguagesMenuMobile" }
);
